<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12)
        v-toolbar(color="primary" dense flat)
          v-icon(class="white--text") fa-hourglass-half
          v-toolbar-title(class="white--text") 注文一覧(要配送登録)

    v-layout(row wrap)
      v-flex(xs12)

        v-alert(outline type="success" value="true" v-if="orderedList.length === 0")
          span 配送登録が必要な注文はありません。

        ul.app-list-slim(v-else)
          li.list-header
            ul
              li.w40px.align-right #
              li.w140px 注文番号
              li.w200px 注文時刻
              li.w180px 注文者
              li.w180px.align-right 注文金額(税込)
              li.w80px.align-center &nbsp;
          li
            ul(
              v-for="row, index in orderedList"
              :key="row.id"
            )
              li.w40px.align-right {{index + 1}}
              li.w140px {{row.id}}
              li.w200px {{row.order.summary.order_timestamp|date('YYYY/MM/DD HH:mm:ss')}}
              li.w180px {{row.order.customer.name}}
                span.rem9.grey--text.ml-2 様
              li.w180px.align-right {{row.order.summary.grand_total|number}}
                span.rem9.grey--text.ml-2 円
              li.w80px.align-center
                app-shipment(
                  :row="row"
                  v-on:complete="onShipped"
                )

    v-layout.mt-5(row wrap)
      v-flex(xs12)
        v-toolbar(color="grey" dense flat)
          v-icon(class="white--text") fa-check
          v-toolbar-title(class="white--text") 配送登録完了(直近{{recent}}件)

    v-layout(row wrap)
      v-flex(xs12)
        ul.app-list-slim
          li.list-header
            ul
              li.w40px.align-right #
              li.w140px 注文番号
              li.w200px 注文時刻
              li.w180px 注文者
              li.w180px.align-right 注文金額(税込)
              li.w180px 問い合わせ番号
              li.w140px 担当者
              li.w200px 配送入力時刻
              li.w80px コメント
              li.w80px.align-center &nbsp;
          li
            ul(
              v-for="row, index in recentShippedList"
              :key="row.id"
            )
              li.w40px.align-right {{index + 1}}
              li.w140px {{row.id}}
              li.w200px {{row.order.summary.order_timestamp|date('YYYY/MM/DD HH:mm:ss')}}
              li.w180px {{row.order.customer.name}}
                span.rem9.grey--text.ml-2 様
              li.w180px.align-right {{row.order.summary.grand_total|number}}
                span.rem9.grey--text.ml-2 円
              li.w180px {{row.shipment.no}}
              li.w140px {{row.shipment.inputter}}
              li.w200px {{row.shipment.shipment_timestamp|date('YYYY/MM/DD HH:mm:ss')}}
              li.w80px.align-center
                v-tooltip(bottom v-if="row.shipment.comment")
                  span.success--text(slot="activator") 有
                  span {{row.shipment.comment}}
                span.grey--text(v-else) -
              li.w80px.align-center
                app-shipment(
                  :row="row"
                  :viewOnly="true"
                )

</template>

<script>
import AppShipment from './shipment'

export default {
  components: {
    AppShipment
  },
  data () {
    return {
      recent: 10,
      orderedList: [],
      recentShippedList: []
    }
  },
  created () {
    this.reload()
  },
  methods: {
    onShipped () {
      this.reload()
    },
    reload () {
      this.$ajax.get('/resources/orders').then(response => {
        this.orderedList = response.data
      })
      const recentParams = this.$url.buildQuery({
        count: this.recent
      })
      this.$ajax
        .get(`/resources/recent_shipped_orders?${recentParams}`)
        .then(response => {
          this.recentShippedList = response.data
        })
    }
  }
}
</script>

<style scoped lang="stylus">
li.list-header ul li {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Staff/Dashboard/index.vue